export default function MacWindow({ title = "untitled", children }) {
  return (
    <div className="motif-macwin">
      <div className="bar">
        <span className="box"></span>
        <span className="title">{title}</span>
        <span className="box" style={{ visibility: "hidden" }}></span>
      </div>
      <div className="body">{children}</div>
    </div>
  );
}
